module.exports = __webpack_public_path__ + "8400b4ab760a6e3b6b917b1243f83e93.svg";